<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { colors } from 'quasar'
import { generateContrastText } from '@/utils/color'
import CheckIcon from '@/assets/svg/check_icon.svg?component'
import { useGtm } from '@/hooks/useGtm'
export default defineComponent({
  name: 'CardItem',
  components: { CheckIcon },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isActive: {
      type: Boolean,
      default: () => false,
    },
    computeStyle: {
      type: Array,
      default: () => [],
    },
    iconClass: {
      type: String,
      default: () => '',
    },
  },
  emits: ['selected'],
  setup(props, { emit }) {
    const { pushGtm } = useGtm()
    const refCard = ref()

    const isTransitionItem = computed(() => {
      return [
        'function_transitions_gray',
        'function_transitions_brown',
        'function_transitions_xtractive',
        'function_luthina_photo_gray',
        'function_luthina_photo_brown',
        'function_luthina_photo_surf_blue',
      ].includes(props.item.value)
    })

    const textColor = computed(() => {
      if (props.item.renderColor.startsWith('linear-gradient'))
        return '#000'

      return generateContrastText(props.item.renderColor, 140)
    })
    const className = computed(() => {
      return [
        props.iconClass,
        'ellipsis-3-lines',
        'text-wrap',
        'text-caption',
        'text-center',
        'text-weight-medium',
      ]
    })
    return {
      refCard,
      className,
      isTransitionItem,
      styling: [
        {
          height: '120px',
          width: '80px',
          ...(props.item?.renderColor && {
            background: props.item.renderColor,
          }),
        },
        ...props.computeStyle,
      ],
      bgLighten: props.item?.renderColor
        ? colors.lighten(props.item.renderColor, 70)
        : '#fff',
      textStyle: {
        lineHeight: '1.25',
        color: textColor.value,
      },
      selected: (item) => {
        emit('selected', item)
        pushGtm(refCard.value?.$el || refCard.value)
      },
    }
  },
})
</script>

<template>
  <q-item
    ref="refCard"
    v-ripple
    clickable
    class="q-pa-none q-mr-sm relative-position"
    :glasson-click="item.gtmKey"
    @click="selected(item)"
  >
    <div v-if="isTransitionItem" class="relative-position row shadow-2">
      <div
        class="half-left"
        :style="[styling, { background: bgLighten }]"
      />
      <div
        class="half-right"
        :style="[styling, { 'margin-left': '-80px' }]"
      />
      <div
        class="absolute fit column items-center justify-between q-pb-xs"
        :style="textStyle"
      >
        <span>&nbsp;</span>
        <CheckIcon v-if="isActive" :class="iconClass" :style="textStyle" />
        <div :class="className" :style="textStyle">
          {{ item.label }}
        </div>
      </div>
    </div>
    <div
      v-else
      ref="refCard"
      class="column items-center justify-between shadow-2 q-pa-xs"
      :style="styling"
    >
      <span>&nbsp;</span>
      <CheckIcon v-if="isActive" :class="iconClass" :style="textStyle" />
      <div :class="className" :style="textStyle" v-html="item.label" />
    </div>
  </q-item>
</template>
